const getters = {
    accountDetail(state) {
        return state.accountDetail;
    },
    authenticated(state) {
        return state.authenticated;
    }
};

export default getters;